<template>
  <vs-popup class="customer-credit-note-pop-up"
            id="popup"
            title="LINK CREDIT NOTE TO ORDERS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickCreateCreditNote)" autocomplete="off">

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="credit_amount" name="credit_amount" rules="" v-slot="{ errors }">
                <small class="label"><span class="text-bold">Credit amount </span></small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{account_currency}}</span>
                    </div>
                  </template>
                  <vs-input disabled v-model="credit_note_details.credit_amount"  name="credit_amount" class="w-full" label=""/>
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider vid="credit_amount" name="credit_amount" rules="" v-slot="{ errors }">
                <small class="label"><span class="text-bold">Remaining credit amount </span></small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-success">
                      <span>{{account_currency}}</span>
                    </div>
                  </template>
                  <vs-input disabled v-model="credit_note_details.remaining_credit_amount"  name="credit_amount" class="w-full" label=""/>
                </vx-input-group>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-16">
            <div class="vx-col w-full">
              <ValidationProvider vid="product_order_code" name="product_order_code" rules="required" v-slot="{ errors }">
                <small class="label">Original SO raised against</small>
                <vs-input disabled v-model="credit_note_details.belongs_to_product_order.product_order_code" name="product_order_code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <hr>

          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button @click.stop="onClickAddOrder()" size="small" class="ml-auto mt-2 mb-4">Add order</vs-button>
          </div>
          <span v-for="(order, index_order) in linked_product_orders" :key="index_order">
             <div class="vx-row mb-3">
              <div class="vx-col md:w-2/5 w-full">
                <ValidationProvider :vid="index_order+'product_order_id'" :name="index_order+'product_order_id'" rules="required" v-slot="{ errors }">
                  <small class="label">Product order</small>
                  <v-select :clearable="false" label="product_order_code" v-model="order.product_order_id" :reduce="option => option.id" :options="product_orders" :dir="$vs.rtl ? 'rtl' : 'ltr'"/>
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-2/5 w-full">
                <ValidationProvider :vid="index_order+'amount'" :name="index_order+'amount'" rules="required" v-slot="{ errors }">
                  <small class="label">Amount ({{account_currency}})</small>
                  <vs-input v-model="order.amount"   name="amount" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
                </ValidationProvider>
              </div>
               <div class="vx-col md:w-1/5 w-full">
                  <small class="label">&nbsp;</small>
                 <vx-tooltip class="ml-2" text="Remove" position="top">
                  <vs-button @click.stop="onClickRemoveOrder(index_order)"
                             size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash"></vs-button>
                 </vx-tooltip>
              </div>
             </div>
          </span>

          <vs-alert v-if="isExceedCreditAmount" class="h-12 mt-4" color="danger" active="true" icon-pack="feather" icon="icon-alert-circle">
            Total amount is less than remaining credit amount
          </vs-alert>


          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button :disabled="isExceedCreditAmount" button="submit" class="ml-auto mt-2">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const CustomerRepository = RepositoryFactory.get('customer')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  function initialState() {
    return {
      open: false,
      credit_note_id: '',
      customer_id: '',
      createForm: {},
      credit_limit: '',
      isDataAvailable: false,
      product_orders: [],
      credit_note_details: {},
      linked_product_orders: [
        { product_order_id: null, amount: null }
      ],
    }
  }

export default {
  name: 'CreateCustomerCreditNotePopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: '',
    }
  },
  methods:{
    async openPopup (credit_note_id, customer_id) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.credit_note_id = credit_note_id
        this.customer_id = customer_id
        this.open = true;
        // await this.fetchCustomerAccountCredit()
        await this.fetchCustomerCreditNote()
        await this.fetchCustomerProductOrders()
      } catch (error) {

      }
    },
    async onClickCreateCreditNote () {
      const vue = this;
      this.$vs.loading()
       try {
         const payload = {}
         payload.product_orders = this.linked_product_orders.map((n) => {
           n.amount = Number(n.amount).toFixed(2)
           return n
         })
         await CustomerRepository.linkCustomerCreditNoteToOrders(this.credit_note_id, payload)
         this.showSuccessMessage('Customer credit note linked successfully')
         vue.open = false;
         await vue.$parent.refreshData()
       }catch (e) {
         this.$vs.loading.close()
         this.convertAndNotifyError(e)
       }
      this.$vs.loading.close()
    },
    async fetchCustomerAccountCredit(){
      this.$vs.loading()
      try {
        const {data} = await CustomerRepository.getCustomerAccountCredit(this.customer_id)
        this.credit_limit = data.data.credit_limit
        this.isDataAvailable = true
      } catch (e) {
        // this.convertAndNotifyError(e)
        this.isDataAvailable = false
        this.credit_limit = '-'
      }
      this.$vs.loading.close()
    },
    async fetchCustomerProductOrders(){
      this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getListOfProductOrdersNoPagination(this.customer_id)).data
        this.product_orders = data.filter((n) => this.credit_note_details.belongs_to_product_order.product_order_code !== n.product_order_code)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async fetchCustomerCreditNote(){
      this.$vs.loading()
      try {
        const {data} = (await CustomerRepository.getCustomerCreditNote(this.credit_note_id)).data
        this.credit_note_details = data
        if(this.credit_note_details.credit_note_used_by.length > 0) {
          this.linked_product_orders = this.credit_note_details.credit_note_used_by.map((n) => {
            return {product_order_id: n.id, amount: n.pivot.amount}
          })
        }
        this.credit_note_details.remaining_credit_amount = Number(this.credit_note_details.remaining_credit_amount).toFixed(2)
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    onClickAddOrder() {
      this.linked_product_orders.push({ product_order_id: null, amount: null })
    },
    onClickRemoveOrder(index) {
      this.linked_product_orders.splice(index, 1)
    }
  },
  async mounted () {

  },
  computed: {
    isExceedCreditAmount: function() {
      const linked_so_amount_total = this.linked_product_orders.reduce((a, b) => a + Number(b.amount), 0)
      return linked_so_amount_total > this.credit_note_details.credit_amount
    }
  },
  components: {
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .customer-credit-note-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
  }

</style>
